import { componentSpacing04 } from '../../tokens';
var selectorLabelDefaultTheme = {
  Label: {
    base: {
      paddingLeft: componentSpacing04
    },
    disabled: {
      color: '$color.neutral.04'
    },
    error: {
      color: '$color.error.main'
    },
    disabled__error: {
      color: '$color.error.lighter'
    }
  }
};
export default selectorLabelDefaultTheme;